import axios from "axios";

export const url = "https://aruhifragrances.com";
// export const url = "http://localhost:5000";
// Create an Axios instance
const api = axios.create({
  // baseURL: "https://aruhifragrances.com/api",
  baseURL: `${url}/api`, // your backend
  // headers: {
  //   "Content-Type": "application/json",
  // },
});

// // Request interceptor – show loader before every request
// api.interceptors.request.use(
//   (config) => {
//     const setLoading = getLoadingSetter();
//     if (setLoading) setLoading(true);
//     return config;
//   },
//   (error) => {
//     const setLoading = getLoadingSetter();
//     if (setLoading) setLoading(false);
//     return Promise.reject(error);
//   },
// );

// // Response interceptor – hide loader after response
// api.interceptors.response.use(
//   (response) => {
//     const setLoading = getLoadingSetter();
//     if (setLoading) setLoading(false);
//     return response;
//   },
//   (error) => {
//     const setLoading = getLoadingSetter();
//     if (setLoading) setLoading(false);
//     return Promise.reject(error);
//   },
// );

export default api;
